<template>
  <div v-show="show">
    <header class="header-main">
      <div class="containers">
        <router-link to="/" class="logo-header"><img :src="getTranslations.project_logo_img" alt=""></router-link>
        <nav class="main-nav">
          <a :href="getTranslations.project_my_orange_link"
             target="_blank"
             :class="['my_orange', getTranslations.project_my_orange_logo ? '': 'hide']">
            <img :src="getTranslations.project_my_orange_logo" alt="">
          </a>
          <ul class="main-nav__list" id="get_started_menu">
            <li v-if="!hidePrizePage"><router-link to="/prizes" :class="getActiveTabClass('/prizes')">{{ getTranslations.visitor_visitor_header_prizes }}</router-link></li>
            <li v-if="!hideWinners"><router-link to="/winners" :class="getActiveTabClass('/winners')">{{ getTranslations.visitor_visitor_header_winners }}</router-link></li>
            <li><router-link to="/howItWorks" :class="getActiveTabClass('/howItWorks')">{{ getTranslations.visitor_visitor_header_how_it_works }}</router-link></li>
            <li class="main-nav__list__buttons">
              <router-link to="/login" class="btn btn--outline btn--small">{{ getTranslations.visitor_visitor_header_login }}</router-link>
              <a @click.prevent="encryptUrlBuilder"
                 style="cursor:pointer"
                 class="btn btn--white btn--small">{{ getTranslations.visitor_visitor_header_register }}</a>
              <div class="clearfix"></div>
            </li>
          </ul>
          <ul class="main-nav__lang" style="cursor:pointer" v-if="!hideLangSelection">
            <li class="dropdown">
              <a><i class="icon-planet"></i><i class="icon-arrow-down"></i></a>
              <ul>
                <li v-for="(value, key) in availableLocales" :key="key">
                  <a @click.prevent="changeLanguage(key)" :class="getActiveTabLocale(key)">{{ value }} </a>
                </li>
              </ul>
            </li>
          </ul>
          <router-link to="/login" class="btn btn--outline btn--small btn--icon login-btn-nav" >
            <i class="icon-profile"></i><span>{{ getTranslations.visitor_visitor_header_login }}</span>
          </router-link>
          <a @click.prevent="encryptUrlBuilder"
             class="btn btn--white btn--small hidden-md-down"
             style="cursor:pointer">
            {{ getTranslations.visitor_visitor_header_register }}
          </a>
          <button data-menu="get_started_menu" class="nav__toggle"><span></span></button>
        </nav>
      </div>
    </header>
    <router-view></router-view>
    <footer class="footer-main" v-if="logoOnFooter">
      <div class="containers">
        <nav class="footer-nav">
          <ul class="footer-nav__list">
            <li><a :href="getTranslationByOperator(multiOperatorInfo.multiOperatorOrdinal, 'project_config_visitor_register_3_terms_and_conditions')" target="_blank">{{ getTranslations.visitor_t_and_c }}</a></li>
            <li><a @click.prevent="toCreditsPage" style="cursor:pointer">{{ getTranslations.visitor_visitor_credits }}</a></li>
            <li><a :href="getTranslationByOperator(multiOperatorInfo.multiOperatorOrdinal, 'project_privacy_and_policy')" target="_blank">{{ getTranslations.visitor_visitor_privacy_policy }}</a></li>
          </ul>
        </nav>
      </div>
    </footer>
    <simplify-registration v-if="showSimpleRegistrationModal"
                           @close="showSimpleRegistrationModal = false;">
    </simplify-registration>
    <sub-verify-wifi v-if="HE_ERROR_CODE"
                     @close="HE_ERROR_CODE = false;">
    </sub-verify-wifi>
    <operator-selection v-if="getSelectOperatorModalChoice()"
                        @close="toggleSelectOperatorModal(false);">
    </operator-selection>

    <loading v-if="showLoadingModal"
             @close="showLoadingModal = false">
    </loading>
  </div>
</template>

<script>
/* eslint no-console: "off" */
import Vue from 'vue';
import { mapState, mapGetters, mapMutations, mapActions } from 'vuex';
import IntegrationMixin from '@/common/mixins/integration';
import RegistrationFlowMixin from '@/common/mixins/flow';
import simplifyRegistration from '@/components/home/modals/SimplifyRegistration';
import subVerifyWifi from '@/components/home/modals/SubscriptionVerifyWifi';
import operatorSelection from '@/components/home/modals/OperatorSelectionModal';
import loading from '@/components/home/modals/Loading';
import { handleLanguageDropdown, handleBurgerButton, closeTab } from '../../common/jQuery';

const moment = require('moment');

Vue.use(require('vue-moment'), {
  moment,
});

export default {
  name: 'navigation-header',
  mixins: [IntegrationMixin, RegistrationFlowMixin],
  components:
      {
        simplifyRegistration,
        subVerifyWifi,
        operatorSelection,
        loading,
      },
  data() {
    return {
      currentTabPath: '',
      showSimpleRegistrationModal: false,
      show: true,
      showLoadingModal: false,
    };
  },
  // eslint-disable-next-line
  beforeRouteEnter(to, from, next) {
    next((vm) => {
      if (vm.hidePage()) vm.showPage(false);
      vm.getIntegration(to);
    });
  },
  created() {
    this.currentTabPath = sessionStorage.getItem('visitorCurrentTabPath');
  },
  mounted() {
    console.log(this.getDisplayedLocale);
    this.$nextTick(() => {
      handleLanguageDropdown();
      handleBurgerButton();
    });
  },
  beforeRouteUpdate(to, from, next) {
    // eslint-disable-next-line
    $(window).scrollTop(0);
    this.getIntegration(to);
    console.log(`from: ${from.path}`);
    console.log(`to: ${to.path}`);
    this.currentTabPath = to.path;
    sessionStorage.setItem('visitorCurrentTabPath', to.path);
    closeTab();
    next();
  },
  methods: {
    showPage(value) {
      this.show = value;
    },
    encryptUrlBuilder() {
      if (!this.hasWebRegister()) {
        this.showSimpleRegistrationModal = true;
      } else {
        this.registrationRedirect();
      }
    },
    getIntegration(to) {
      if (to.path === '/') this.checkForRegisterRedirect(to);
      else this.showPage(true);
    },
    checkForRegisterRedirect(to) {
      this.getIntegrationParametersCheck()(to);
    },
    ...mapActions('i18n', [
      'getTranslationsFile',
    ]),
    ...mapActions('common', [
      'getDecodedStatus',
      'getUserExistsInCore',
      'getUserIsRegistered',
    ]),
    ...mapActions('profile', [
      'storeVisitorWinners',
      'storeAvailablePrizeTypes',
    ]),
    ...mapMutations('i18n', [
      'setLocale',
      'changeCSSFile',
    ]),
    ...mapMutations('common', [
      'setUserLanguage',
    ]),
    ...mapMutations('profile', [
      'setRegistrationInfo',
    ]),
    toCreditsPage() {
      this.$router.push('/credits');
    },
    changeLanguage(newValue) {
      console.log(`New Language ${newValue}`);
      this.setUserLanguage(newValue);
      localStorage.setItem('locale', newValue);
      this.setLocale({ currentLocale: newValue });
      this.getTranslationsFile().then(() => {
        moment.locale(this.getLocale.toLowerCase());
        this.storeVisitorWinners(localStorage.getItem('locale')).then(() => {
          this.storeAvailablePrizeTypes(localStorage.getItem('locale')).then(() => {
            this.changeCSSFile();
          });
        });
      });
    },
    getActiveTabLocale(key) {
      return this.getLocale === key ? 'active' : '';
    },
    getActiveTabClass(path) {
      return this.currentTabPath === path ? 'active' : '';
    },

  },
  computed: {
    ...mapState('i18n', [
      'availableLocales',
    ]),
    ...mapState('common', [
      'hideLangSelection',
      'hidePrizePage',
      'hideWinners',
      'logoOnFooter',
      'multiOperatorInfo',
    ]),
    ...mapGetters('i18n', [
      'getLocale',
      'getDisplayedLocale',
      'getTranslationByOperator',
      'getTranslations',
    ]),
  },
};
</script>



// WEBPACK FOOTER //
// src/components/visitor/Visitor.vue